// // ============================================================
// // src/components/Doctors.js
// // ✅ Passes hospitalId to fetch only THIS hospital's doctors
// // ============================================================
// import React, { useEffect, useState, useCallback } from "react";
// import { useHospital } from "../context/HospitalContext";

// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const CARD_COLORS = {
//   teal: "linear-gradient(160deg,#0d7377 0%,#14a0a5 60%,#0a8f94 100%)",
//   navy: "linear-gradient(160deg,#0a1628 0%,#1a3a6b 100%)",
//   gold: "linear-gradient(160deg,#7c5a0a 0%,#b8860b 60%,#c9a845 100%)",
//   plum: "linear-gradient(160deg,#3b0764 0%,#6b21a8 100%)",
//   rose: "linear-gradient(160deg,#881337 0%,#be123c 100%)",
//   slate: "linear-gradient(160deg,#1e293b 0%,#475569 100%)",
// };

// const getBg = (id) => CARD_COLORS[id] || CARD_COLORS.teal;

// export default function Doctors() {
//   const { hospital } = useHospital(); // ✅ Get current hospital
//   const [doctors, setDoctors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(false);

//   const fetchDoctors = useCallback(() => {
//     setLoading(true);
//     setError(false);

//     // ✅ Pass hospitalId so only THIS hospital's doctors are returned
//     const hospitalId = hospital?._id || "";
//     const url = hospitalId
//       ? `${BASE_URL}/doctors/manage/public?hospitalId=${hospitalId}&_t=${Date.now()}`
//       : `${BASE_URL}/doctors/manage/public?_t=${Date.now()}`;

//     fetch(url, { cache: "no-store" })
//       .then((r) => {
//         if (!r.ok) throw new Error("HTTP " + r.status);
//         return r.json();
//       })
//       .then((data) => {
//         setDoctors(Array.isArray(data) ? data : []);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Doctors fetch error:", err);
//         setError(true);
//         setLoading(false);
//       });
//   }, [hospital?._id]); // ✅ Re-fetch when hospital changes

//   useEffect(() => {
//     fetchDoctors();
//   }, [fetchDoctors]);

//   const css = `
//     .doctors-section { background: var(--bg-light, #f9f7f4); padding: 100px 0; }
//     .doctors-inner   { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
//     .doctors-header  { text-align: center; margin-bottom: 60px; }
//     .doctors-grid    { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 32px; }
//     .doc-card {
//       background: #fff; border-radius: 20px; overflow: hidden;
//       box-shadow: 0 4px 24px rgba(0,0,0,0.09);
//       transition: transform 0.28s ease, box-shadow 0.28s ease; cursor: default;
//     }
//     .doc-card:hover { transform: translateY(-6px); box-shadow: 0 12px 40px rgba(0,0,0,0.14); }
//     .doc-card-img {
//       height: 260px; position: relative;
//       display: flex; align-items: center; justify-content: center; overflow: hidden;
//     }
//     .doc-card-badge {
//       position: absolute; top: 18px; right: 18px;
//       background: rgba(255,255,255,0.18); backdrop-filter: blur(8px);
//       -webkit-backdrop-filter: blur(8px); border: 1px solid rgba(255,255,255,0.32);
//       border-radius: 20px; font-size: 12px; font-weight: 700;
//       color: #fff; padding: 5px 16px; letter-spacing: 0.3px;
//     }
//     .doc-card-img img {
//       width: 150px; height: 150px; border-radius: 50%;
//       object-fit: cover; object-position: center top;
//       border: 3px solid rgba(255,255,255,0.35);
//     }
//     .doc-card-emoji { font-size: 90px; opacity: 0.75; }
//     .doc-card-body  { padding: 24px 26px 26px; }
//     .doc-card-name  {
//       font-family: "Cormorant Garamond", serif; font-size: 24px;
//       font-weight: 700; color: #0a1628; margin-bottom: 4px;
//     }
//     .doc-card-spec  { font-size: 13px; font-weight: 700; color: #0d7377; margin-bottom: 12px; }
//     .doc-card-bio   { font-size: 14px; color: #555; line-height: 1.65; margin-bottom: 18px; min-height: 44px; }
//     .doc-card-meta  { display: flex; align-items: center; gap: 20px; font-size: 13px; color: #666; }
//     .doctors-loading { text-align: center; padding: 60px 0; color: #94a3b8; font-size: 15px; }
//     .doctors-retry-btn {
//       margin-top: 14px; padding: 9px 22px; border-radius: 8px;
//       border: 1px solid #d1d5db; background: #fff;
//       color: #0d7377; font-size: 13px; font-weight: 700; cursor: pointer;
//     }
//     @media (max-width: 768px) {
//       .doctors-grid    { grid-template-columns: 1fr; }
//       .doctors-section { padding: 70px 0; }
//     }
//     @media (max-width: 480px) {
//       .doc-card-img     { height: 220px; }
//       .doc-card-img img { width: 120px; height: 120px; }
//       .doc-card-emoji   { font-size: 72px; }
//     }
//   `;

//   return (
//     <section className="doctors-section" id="doctors">
//       <style>{css}</style>
//       <div className="doctors-inner">
//         <div className="doctors-header">
//           <div className="section-tag">Our Specialists</div>
//           <h2 className="section-title">
//             Meet Our Expert
//             <br />
//             <em>Dental Team</em>
//           </h2>
//           <p
//             className="section-desc"
//             style={{ maxWidth: 540, margin: "0 auto" }}
//           >
//             Our experienced dentists bring compassion, cutting-edge skills, and
//             personalised care to every smile they transform.
//           </p>
//         </div>

//         {loading ? (
//           <div className="doctors-loading">Loading our team...</div>
//         ) : error ? (
//           <div className="doctors-loading">
//             <div>Could not load doctor profiles. Please try again.</div>
//             <button className="doctors-retry-btn" onClick={fetchDoctors}>
//               🔄 Retry
//             </button>
//           </div>
//         ) : doctors.length === 0 ? (
//           <div className="doctors-loading">
//             Our team information is coming soon.
//           </div>
//         ) : (
//           <div className="doctors-grid">
//             {doctors.map((doc) => (
//               <div key={doc._id} className="doc-card">
//                 <div
//                   className="doc-card-img"
//                   style={{ background: getBg(doc.cardColor) }}
//                 >
//                   {doc.badgeLabel && (
//                     <div className="doc-card-badge">{doc.badgeLabel}</div>
//                   )}
//                   {doc.image ? (
//                     <img src={doc.image} alt={doc.name} />
//                   ) : (
//                     <div className="doc-card-emoji">🧑‍⚕️</div>
//                   )}
//                 </div>
//                 <div className="doc-card-body">
//                   <div className="doc-card-name">{doc.name}</div>
//                   <div className="doc-card-spec">{doc.specialty}</div>
//                   {doc.bio && <div className="doc-card-bio">{doc.bio}</div>}
//                   <div className="doc-card-meta">
//                     {doc.experience && (
//                       <span>🎓 {doc.experience} yrs exp.</span>
//                     )}
//                     {doc.rating && <span>⭐ {doc.rating} ★</span>}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// ============================================================
// src/components/Doctors.js
// ✅ Specialty text wired via getSpecialtyText()
// ============================================================
import React, { useEffect, useState, useCallback } from "react";
import { useHospital } from "../context/HospitalContext";
import { getSpecialtyText } from "../utils/specialtyText";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const CARD_COLORS = {
  teal: "linear-gradient(160deg,#0d7377 0%,#14a0a5 60%,#0a8f94 100%)",
  navy: "linear-gradient(160deg,#0a1628 0%,#1a3a6b 100%)",
  gold: "linear-gradient(160deg,#7c5a0a 0%,#b8860b 60%,#c9a845 100%)",
  plum: "linear-gradient(160deg,#3b0764 0%,#6b21a8 100%)",
  rose: "linear-gradient(160deg,#881337 0%,#be123c 100%)",
  slate: "linear-gradient(160deg,#1e293b 0%,#475569 100%)",
};
const getBg = (id) => CARD_COLORS[id] || CARD_COLORS.teal;

export default function Doctors() {
  const { hospital } = useHospital();
  const t = getSpecialtyText(hospital.type);
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchDoctors = useCallback(() => {
    setLoading(true);
    setError(false);
    const hospitalId = hospital?._id || "";
    const url = hospitalId
      ? `${BASE_URL}/doctors/manage/public?hospitalId=${hospitalId}&_t=${Date.now()}`
      : `${BASE_URL}/doctors/manage/public?_t=${Date.now()}`;
    fetch(url, { cache: "no-store" })
      .then((r) => {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then((data) => {
        setDoctors(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Doctors fetch error:", err);
        setError(true);
        setLoading(false);
      });
  }, [hospital?._id]);

  useEffect(() => {
    fetchDoctors();
  }, [fetchDoctors]);

  const css = `
    .doctors-section { background: var(--bg-light, #f9f7f4); padding: 100px 0; }
    .doctors-inner   { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
    .doctors-header  { text-align: center; margin-bottom: 60px; }
    .doctors-grid    { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 32px; }
    .doc-card { background: #fff; border-radius: 20px; overflow: hidden; box-shadow: 0 4px 24px rgba(0,0,0,0.09); transition: transform 0.28s ease, box-shadow 0.28s ease; cursor: default; }
    .doc-card:hover { transform: translateY(-6px); box-shadow: 0 12px 40px rgba(0,0,0,0.14); }
    .doc-card-img { height: 260px; position: relative; display: flex; align-items: center; justify-content: center; overflow: hidden; }
    .doc-card-badge { position: absolute; top: 18px; right: 18px; background: rgba(255,255,255,0.18); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); border: 1px solid rgba(255,255,255,0.32); border-radius: 20px; font-size: 12px; font-weight: 700; color: #fff; padding: 5px 16px; letter-spacing: 0.3px; }
    .doc-card-img img { width: 150px; height: 150px; border-radius: 50%; object-fit: cover; object-position: center top; border: 3px solid rgba(255,255,255,0.35); }
    .doc-card-emoji { font-size: 90px; opacity: 0.75; }
    .doc-card-body  { padding: 24px 26px 26px; }
    .doc-card-name  { font-family: "Cormorant Garamond", serif; font-size: 24px; font-weight: 700; color: #0a1628; margin-bottom: 4px; }
    .doc-card-spec  { font-size: 13px; font-weight: 700; color: #0d7377; margin-bottom: 12px; }
    .doc-card-bio   { font-size: 14px; color: #555; line-height: 1.65; margin-bottom: 18px; min-height: 44px; }
    .doc-card-meta  { display: flex; align-items: center; gap: 20px; font-size: 13px; color: #666; }
    .doctors-loading { text-align: center; padding: 60px 0; color: #94a3b8; font-size: 15px; }
    .doctors-retry-btn { margin-top: 14px; padding: 9px 22px; border-radius: 8px; border: 1px solid #d1d5db; background: #fff; color: #0d7377; font-size: 13px; font-weight: 700; cursor: pointer; }
    @media (max-width: 768px) { .doctors-grid { grid-template-columns: 1fr; } .doctors-section { padding: 70px 0; } }
    @media (max-width: 480px) { .doc-card-img { height: 220px; } .doc-card-img img { width: 120px; height: 120px; } .doc-card-emoji { font-size: 72px; } }
  `;

  return (
    <section className="doctors-section" id="doctors">
      <style>{css}</style>
      <div className="doctors-inner">
        <div className="doctors-header">
          {/* ✅ Specialty text */}
          <div className="section-tag">{t.doctorsTag}</div>
          <h2 className="section-title">
            {t.doctorsTitle.includes("\n")
              ? t.doctorsTitle.split("\n").map((line, i) =>
                  i === 1 ? (
                    <span key={i}>
                      <br />
                      <em>{line}</em>
                    </span>
                  ) : (
                    <span key={i}>{line}</span>
                  ),
                )
              : (() => {
                  const words = t.doctorsTitle.split(" ");
                  const half = Math.ceil(words.length / 2);
                  return (
                    <>
                      {words.slice(0, half).join(" ")}
                      <br />
                      <em>{words.slice(half).join(" ")}</em>
                    </>
                  );
                })()}
          </h2>
          <p
            className="section-desc"
            style={{ maxWidth: 540, margin: "0 auto" }}
          >
            {t.doctorsDesc}
          </p>
        </div>

        {loading ? (
          <div className="doctors-loading">Loading our team...</div>
        ) : error ? (
          <div className="doctors-loading">
            <div>Could not load doctor profiles. Please try again.</div>
            <button className="doctors-retry-btn" onClick={fetchDoctors}>
              🔄 Retry
            </button>
          </div>
        ) : doctors.length === 0 ? (
          <div className="doctors-loading">
            Our team information is coming soon.
          </div>
        ) : (
          <div className="doctors-grid">
            {doctors.map((doc) => (
              <div key={doc._id} className="doc-card">
                <div
                  className="doc-card-img"
                  style={{ background: getBg(doc.cardColor) }}
                >
                  {doc.badgeLabel && (
                    <div className="doc-card-badge">{doc.badgeLabel}</div>
                  )}
                  {doc.image ? (
                    <img src={doc.image} alt={doc.name} />
                  ) : (
                    <div className="doc-card-emoji">🧑‍⚕️</div>
                  )}
                </div>
                <div className="doc-card-body">
                  <div className="doc-card-name">{doc.name}</div>
                  <div className="doc-card-spec">{doc.specialty}</div>
                  {doc.bio && <div className="doc-card-bio">{doc.bio}</div>}
                  <div className="doc-card-meta">
                    {doc.experience && (
                      <span>🎓 {doc.experience} yrs exp.</span>
                    )}
                    {doc.rating && <span>⭐ {doc.rating} ★</span>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
